import {isRouteErrorResponse, useNavigate, useRouteError} from '@remix-run/react'

import {Button} from '#app/ui/button'
import {AccessDeniedImage} from '#app/ui/images/access-denied'
import {FixingBugsImage} from '#app/ui/images/fixing-bugs'
import {SafeImage} from '#app/ui/images/safe'
import {SecureLoginImage} from '#app/ui/images/secure-login'
import {ServerDownImage} from '#app/ui/images/server-down'
import {TakenImage} from '#app/ui/images/taken'

export function ErrorBoundary() {
  const {title, description, Image} = useErrorInfo()

  console.log({title, description, Image})

  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md text-center">
        <Image />
        <h1 className="mb-2 mt-8 text-balance text-4xl font-bold">{title}</h1>
        <p className="mb-8 text-muted-foreground">{description}</p>
        <Button onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    </div>
  )
}

function useErrorInfo() {
  const error = useRouteError()
  const statusCode = isRouteErrorResponse(error) ? error.status : 500

  console.log('error', error)

  switch (statusCode) {
    // Bad Request
    case 400:
      return {
        title: 'Invalid Request',
        description: 'The request could not be understood by the server.',
        Image: FixingBugsImage,
      }

    // Unauthorized
    case 401:
      return {
        title: 'Authentication Required',
        description: 'Please log in to access this resource.',
        Image: SecureLoginImage,
      }

    // Forbidden
    case 403:
      return {
        title: 'Access Denied',
        description: "You don't have permission to access this resource.",
        Image: AccessDeniedImage,
      }

    // Not Found
    case 404:
      return {
        title: 'Page Not Found',
        description: "The page you're looking for doesn't exist or has been moved.",
        Image: TakenImage,
      }

    // Unprocessable Entity
    case 422:
      return {
        title: 'Validation Error',
        description: 'The submitted data is invalid. Please check your input and try again.',
        Image: SafeImage,
      }

    // Server Error
    case 500:
      return {
        title: 'Server Error',
        description: 'Something went wrong on our end. Please try again later.',
        Image: ServerDownImage,
      }

    // Default fallback
    default:
      return {
        title: 'Unexpected Error',
        description: 'An unexpected error occurred. Please try again.',
        Image: ServerDownImage,
      }
  }
}
